import {
    ActionIcon,
    Button,
    createStyles,
    Flex,
    Group,
    Loader,
    Paper,
    Popover,
    Text,
} from "@mantine/core";
import {
    IconArrowUpRight,
    IconArrowDownRight,
    IconInfoCircle,
} from "@tabler/icons";
import { get_lottie, get_lottie_obj } from "../common/utils";

const useStyles = createStyles((theme) => ({
    root: {
        padding: theme.spacing.xl * 1.5,
    },

    value: {
        fontSize: 24,
        fontWeight: 700,
        lineHeight: 1,
    },

    diff: {
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
    },

    icon: {
        color:
            theme.colorScheme === "dark"
                ? theme.colors.dark[3]
                : theme.colors.gray[4],
    },

    title: {
        fontWeight: 700,
        textTransform: "uppercase",
    },
}));

const AnalyticsTabs = ({
    title,
    TitleIcon = null,
    AnimateIcon = null,
    number,
    num_suffix = "",
    diff,
    description = "",
    extradescription = "",
    diffprefix = "",
    diffsuffix = "%",
    reverse = false,
}) => {
    const { classes } = useStyles();
    let up = diff > 0;
    const DiffIcon = up ? IconArrowUpRight : IconArrowDownRight;

    if (reverse) {
        up = !up;
    }

    return (
        <Paper shadow="xs" p="md" withBorder w={200} sx={{ margin: "auto" }}>
            <Group position="apart" sx={{ position: "relative" }}>
                <Text size="xs" className={classes.title} color="dimmed">
                    {title}
                </Text>{" "}
                {!!TitleIcon && (
                    <TitleIcon
                        className={classes.icon}
                        size={22}
                        stroke={1.5}
                    />
                )}
                {!!AnimateIcon && AnimateIcon}
            </Group>
            <Group align="flex-end" spacing="xs" mt={25}>
                {number == null && <Loader variant="dots" />}
                {number != null && (
                    <Text className={classes.value}>
                        {number}
                        {num_suffix}
                    </Text>
                )}

                {number != null && diff != 0 && (
                    <Text
                        color={up ? "teal" : "red"}
                        size="sm"
                        weight={500}
                        className={classes.diff}
                    >
                        <span>
                            {diffprefix}
                            {diff}
                            {diffsuffix}
                        </span>
                        <DiffIcon size={16} stroke={1.5} />
                    </Text>
                )}
            </Group>
            <Flex>
                <Text
                    size="xs"
                    color="dimmed"
                    mt={7}
                    sx={() => ({ wordBreak: "break-word" })}
                >
                    {description}
                </Text>
                {!!extradescription && (
                    <Popover
                        width={200}
                        position="bottom"
                        withArrow
                        shadow="md"
                    >
                        <Popover.Target>
                            <ActionIcon>
                                <IconInfoCircle />
                            </ActionIcon>
                        </Popover.Target>
                        <Popover.Dropdown>
                            <Text size="sm">{extradescription}</Text>
                        </Popover.Dropdown>
                    </Popover>
                )}
            </Flex>
        </Paper>
    );
};

export default AnalyticsTabs;
